import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { OfbizField, OfbizForm, OfbizFormField, OfbizFormsService } from '@urbannex/ofbiz-forms';

@Component({
  selector: 'ubs-edit-blog-status',
  templateUrl: './edit-blog-status.component.html',
  styleUrls: ['./edit-blog-status.component.scss']
})
export class EditBlogStatusComponent implements OnInit {
  @Input() statusId:string;
  @Input() formGroupName: string;
  @Input() fields:OfbizFormField<any>[];
  initialState = "view";
  form: FormGroup;
  hasChanged:boolean = false;
  subFormFields:OfbizFormField<any>[] = [];
  displayedValue:string;

  @Output() statusSubmit = new EventEmitter<string>();

  constructor(private rootFormGroup: FormGroupDirective,private ofbizFormsService: OfbizFormsService) { }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    this.setSubFormFields(this.form.controls,this.fields);
    this.onChanges();
  }

  submit(){
    this.statusSubmit.emit(this.form.value); 
  }
  onChanges(){
    this.form.valueChanges.subscribe(data => {
      this.hasChanged = true;
      //console.log("Has changed tracked by valueChanges....");
    });
  }
  /* onChangeEvent(e){
    console.log("Has changed ....");
    this.hasChanged = true;
  } */
  reset(){
    this.form.get("statusId").setValue(this.statusId);
  }

  setSubFormFields(controls:any,fields:OfbizFormField<any>[]):void{
    Object.keys(controls).forEach(key =>{
      let subFormField = fields.find(element => element.name == key);
      if(subFormField != null || subFormField != undefined){
        this.subFormFields.push(subFormField);
        console.log({subFormField:subFormField});
        if(subFormField.controlType == "dropdown"){
          subFormField["allOptionValues"].forEach(element => {
            if(element.key == controls[key].value){
              this.displayedValue = element.description;
            }
          })
          
        }
      }
    });
    this.ofbizFormsService.getFormFields(this.subFormFields)
    .subscribe(data => {
      this.subFormFields = data;
    });
    console.log({controls:controls});
    console.log({subFormFields:this.subFormFields});
    console.log({displayedValue:this.displayedValue});
  }

}
